var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.525,
    height: 19.747,
    viewBox: "0 0 23.525 19.747",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1385",
    "data-name": "Group 1385",
    transform: "translate(-494.975 -1075.33)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3082",
    "data-name": "Path 3082",
    d: "M518.155,1076.853h-2.93v-1.18a.345.345,0,0,0-.689,0v1.18h-3.4v-1.18a.345.345,0,0,0-.689,0v1.18h-3.4v-1.18a.345.345,0,0,0-.689,0v1.18h-3.4v-1.18a.345.345,0,0,0-.69,0v1.18h-3.4v-1.18a.345.345,0,0,0-.69,0v1.18H495.32a.344.344,0,0,0-.345.342v17.54a.344.344,0,0,0,.345.342H514.8a.36.36,0,0,0,.065-.006.366.366,0,0,0,.038-.011l.027-.008a.32.32,0,0,0,.039-.021l.02-.011a.341.341,0,0,0,.051-.041h0l3.361-3.337a.316.316,0,0,0,.038-.046l.01-.015a.307.307,0,0,0,.02-.038l.008-.018a.316.316,0,0,0,.015-.05l0-.008a.309.309,0,0,0,.006-.061V1077.2A.344.344,0,0,0,518.155,1076.853Zm-19.992.685v1.044a.345.345,0,0,0,.69,0v-1.044h3.4v1.044a.345.345,0,0,0,.69,0v-1.044h3.4v1.044a.345.345,0,0,0,.689,0v-1.044h3.4v1.044a.345.345,0,0,0,.689,0v-1.044h3.4v1.044a.345.345,0,0,0,.689,0v-1.044h2.585v2.909H495.665v-2.909Zm-2.5,3.593H517.81v9.925h-3.016a.344.344,0,0,0-.345.342v2.994H495.665Zm19.475,12.778v-2.168h2.184Z",
    fill: "#918f90"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.528916aa4cf07e7cf6cb765f8505b688.svg";
export { ForwardRef as ReactComponent };